import { latestGames } from '../../shared/game-releases';
import { usePlatform } from '../store';
import { HomeGameShelf } from './HomeGameShelf';

export function LatestGames() {
  const { data } = usePlatform();
  return <HomeGameShelf id="island-catalog" title="最新游戏" games={latestGames(data?.games || [])}
    href="/library" linkLabel="全部游戏" showRelease emptyText="新游戏即将登岛"/>;
}
